import {Injectable} from '@angular/core';
import {ConstantService} from "../../services/constant.service";

@Injectable({
	providedIn: 'root'
})
export class ImageService {

	constructor() {
	}

	public getEmbeddedURL(url: string, autoplay: boolean = false): string {

		let id: string;

		if (ConstantService.YOUTUBE_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.YOUTUBE_VIDEO_REGEX)![1];
			return 'https://www.youtube.com/embed/' + id + '?autoplay=' + (autoplay ? '1' : '0');
		} else if (ConstantService.VIMEO_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.VIMEO_VIDEO_REGEX)![1];
			return 'https://player.vimeo.com/video/' + id + '?autoplay=' + (autoplay ? '1' : '0');
		} else {
			return '';
		}
	}

	public getLightURL(url: string, autoplay: boolean = false): string {

		let id: string;

		if (ConstantService.YOUTUBE_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.YOUTUBE_VIDEO_REGEX)![1];
			return 'https://www.youtube.com/watch?v=' + id + '&autoplay=' + (autoplay ? '1' : '0');
		} else if (ConstantService.VIMEO_VIDEO_REGEX.test(url)) {
			id = url.match(ConstantService.VIMEO_VIDEO_REGEX)![1];
			return 'https://player.vimeo.com/video/' + id + '?autoplay=' + (autoplay ? '1' : '0');
		} else {
			return '';
		}
	}
}
